export const DataSocials = {
  facebook:  "https://www.facebook.com/serwisklimfix",
  instagram: "https://www.instagram.com/serwis_klimfix/",
  designer:  "https://www.linkedin.com/in/daria-pyziak-29081b1a6/",
};
